import * as Yup from 'yup';

import { Day, ExportFormat, Frequency, Publisher } from '../../../../../apis/graphql/types';
import { Option } from '../../../../../components/types';
import { Radio, ReportFormFieldNames, ReportFormValues } from './types';

export const NAME_FIELD: ReportFormFieldNames = 'name';
export const FORMAT_FIELD: ReportFormFieldNames = 'format';
export const EMAIL_NOW_FIELD: ReportFormFieldNames = 'emailNow';
export const SCHEDULE_REPORT_FIELD: ReportFormFieldNames = 'scheduleReport';
export const FREQUENCY_FIELD: ReportFormFieldNames = 'frequency';
export const DAYS_FIELD: ReportFormFieldNames = 'days';
export const RECIPIENTS: ReportFormFieldNames = 'recipients';

export const ReportFormValidationSchema = Yup.object().shape({
  name: Yup.string()
    .matches(/^[a-zA-Z0-9 ]/, 'Enter a valid report name')
    .required('Enter report name')
    .min(3, 'Report name must be at least 3 characters')
    .max(128, 'Report name must not exceed 128 characters'),
  format: Yup.mixed<ExportFormat>().oneOf(Object.values(ExportFormat)).required(),
  emailNow: Yup.boolean().required(),
  scheduleReport: Yup.boolean().when(EMAIL_NOW_FIELD, {
    is: (emailNow: boolean) => !emailNow,
    then: Yup.boolean().oneOf([true], 'Schedule report must be checked in case emailNow is empty').required(),
    otherwise: Yup.boolean(),
  }),
  frequency: Yup.mixed<Frequency>().when(SCHEDULE_REPORT_FIELD, {
    is: (scheduleReport: boolean) => scheduleReport,
    then: Yup.mixed<Frequency>().oneOf(Object.values(Frequency)).required(),
    otherwise: Yup.mixed<Frequency>().oneOf(Object.values(Frequency)).required(),
  }),
  days: Yup.array().when([FREQUENCY_FIELD, SCHEDULE_REPORT_FIELD], {
    is: (frequency: Frequency, scheduleReport: boolean) => {
      return frequency === Frequency.Weekly && scheduleReport;
    },
    then: Yup.array()
      .of(Yup.string().oneOf(Object.values(Day), 'Invalid day chosen').required('Day is required'))
      .min(1, 'At least one day is required')
      .required('Day field is required'),
    otherwise: Yup.array().required(),
  }),
});

export const reportInitialValues: ReportFormValues = {
  name: '',
  format: ExportFormat.Pdf,
  emailNow: false,
  scheduleReport: true,
  frequency: Frequency.Weekly,
  days: [Day.Monday],
  recipients: [],
};

export const formatOptions: Radio<ExportFormat>[] = [
  {
    label: 'PDF',
    value: ExportFormat.Pdf,
  },
  {
    label: 'Excel',
    value: ExportFormat.Excel,
  },
];

export const frequencyOptions: Radio<Frequency>[] = [
  {
    label: 'Daily',
    value: Frequency.Daily,
  },
  {
    label: 'Weekly',
    value: Frequency.Weekly,
  },
  {
    label: 'Monthly',
    value: Frequency.Monthly,
    hint: 'You will receive reports on the 1st day of each month.',
  },
];

export const allWeekDays: Option[] = [
  {
    label: 'Monday',
    value: Day.Monday,
  },
  {
    label: 'Tuesday',
    value: Day.Tuesday,
  },
  {
    label: 'Wednesday',
    value: Day.Wednesday,
  },
  {
    label: 'Thursday',
    value: Day.Thursday,
  },
  {
    label: 'Friday',
    value: Day.Friday,
  },
  {
    label: 'Saturday',
    value: Day.Saturday,
  },
  {
    label: 'Sunday',
    value: Day.Sunday,
  },
];

export const publisherOptions: Option[] = [
  {
    label: 'Hulu',
    value: Publisher.Hulu,
  },
  {
    label: 'Disney+',
    value: Publisher.DisneyPlus,
  },
  {
    label: 'DSE',
    value: Publisher.DisneyStreaming,
  },
];
